// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__J1_PL","imageContainer":"Slide_imageContainer__Eaau3","label":"Slide_label__oFpUR","title":"Slide_title__5JhqH","subTitle":"Slide_subTitle__MD3Lp"};